/* eslint-disable react-hooks/exhaustive-deps */
import Typography from '@material-ui/core/Typography';
import OaPopin from '@orientaction/commons/Popin';
import { AdminTestContext } from '@orientaction/Context';
import update from 'immutability-helper';
import type { FC } from 'react';
import { useCallback, useContext, useEffect, useState } from 'react';
import { Card } from '../Card';
import useStyle from './style';
import { Button } from '@material-ui/core';

const style = {
  width: '100%',
};

export interface Item {
  id: number;
  text: string;
}

export interface ContainerState {
  cards: Item[];
}

export const Container: FC = () => {
  const { updateTest, test } = useContext<any>(AdminTestContext);
  const [cards, setCards] = useState<any>();

  const classes = useStyle();

  const renderCard = useCallback(
    (card: any, index: number) => {
      return (
        <Card key={card.id} index={index} id={card.id} title={card.title} moveCard={moveCard} />
      );
    },
    [test?.aglomerations, test?.questionDeletionConfirmPopin]
  );

  const moveCard = useCallback(
    (dragIndex: number, hoverIndex: number) => {
      setCards((prevCards: any) =>
        update(prevCards, {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, prevCards[dragIndex] as any],
          ],
        })
      );
    },
    [test?.aglomerations]
  );

  useEffect(() => {
    if (cards?.length) {
      updateTest({ aglomerations: cards });
    }
  }, [cards]);

  useEffect(() => {
    setCards(test?.aglomerations);
  }, [test?.aglomerations]);

  const generateId = () => Date.now().toString(36) + Math.random().toString(36).substr(2, 9);

  const handleClickAdd = () => {
    const cloneAglomerations = [...test.aglomerations];
    const newAglomeration = {
      id: generateId(),
      isNew: true,
      variables: [],
      questions: [],
    };
    updateTest({ aglomerations: [...cloneAglomerations, newAglomeration] });
  };

  return (
    <>
      <div style={style}>{(cards || []).map((card: any, i: any) => renderCard(card, i))}</div>
      <div className={classes.flexContainer}>
        {cards?.length < 20 && (
          <Button onClick={handleClickAdd} className={classes.btnPrimary}>
            <span className={classes.textHeader}>Ajouter une variable</span>
          </Button>
        )}
      </div>
      {/* <OaPopin
        open={test?.questionDeletionConfirmPopin?.open}
        title={test?.questionDeletionConfirmPopin?.title}
        handleConfirm={test?.questionDeletionConfirmPopin?.handlePopinConfirm}
        handleClose={test?.questionDeletionConfirmPopin?.handlePopinClose}>
        <div className={classes.modalContent}>
          <Typography variant="h6" className={classes.modalText}>
            {test?.questionDeletionConfirmPopin?.content}
          </Typography>
        </div>
      </OaPopin> */}
    </>
  );
};
